export const locationDialogSx = { '& .dialog-content': { overflow: 'visible !important' } };
